'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTranslate;

var _react = require('react');

var _i18nContext = require('./i18n-context');

var _i18nContext2 = _interopRequireDefault(_i18nContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useTranslate() {
  return (0, _react.useContext)(_i18nContext2.default);
}